import React, { useEffect } from "react";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import TextAreaField from "../../../components/form/TextAreaField";
import { addPDOLetter } from "../../../features/projectsSlice";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/form/InputField";
import { closeModal } from "../../../features/modalSLice";
import { useNotification } from "../../../components/notification/NotificationContainer";
import SelectField from "../../../components/form/SelectField";
import { getDepartmentUsers } from "../../../features/usersSlice";
import { zodResolver } from "@hookform/resolvers/zod";
import { addPDOLetterSchema } from "../../../schemas";

const AddPDOLetter = ({ id, name }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const loading = useSelector((state) => state.projects.load.addPDOLetter);
  const users = useSelector((state) => state.users.data);
  const user = useSelector((state) => state.user.userInfo);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(addPDOLetterSchema) });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(addPDOLetter(data));
      if (addPDOLetter.fulfilled.match(res)) {
        addNotification("Project confirmed successfully!", "success");
        dispatch(closeModal());
        return navigate("/requests/pdo-approvals");
      } else {
        addNotification(res.payload.message, "error");
        if (res.payload.code === 412) {
          dispatch(closeModal());
          navigate("/requests/pdo-approvals");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getDepartmentUsers({ id: user.province_id, slug: "pdo" }));
  }, []);

  useEffect(() => {}, [users]);

  return (
    <>
      {id && (
        <div className="min-w-[85vw] sm:min-w-[35rem] lg:min-w-[50rem] max-w-4xl w-full text-text-1/80">
          <div className="flex flex-col justify-center items-center gap-2 py-5 border-b border-bkg2 mb-4 ">
            <h4>Approve Application</h4>
          </div>
          <p className="font-extrabold  mb-4">{name}</p>
          <form
            onSubmit={handleSubmit(onSubmit)}
            method="post"
            encType="multipart/form-data"
          >
            <SelectField
              name="partner_id"
              label="Representative"
              register={register}
              errors={errors.partner_id}
              data={[{ id: null, name: "--Select Representative" }, ...users]}
            />
            <InputField
              name="subject"
              label="Subject"
              errors={errors.subject}
              register={register}
              autoComplete="off"
              type="text"
            />
            <TextAreaField
              register={register}
              label="Body"
              name="body"
              errors={errors.body}
            />

            <InputField
              register={register}
              name="id"
              defaultValue={id}
              type="hidden"
            />
            <ResourseButtons text="Back" submitText="Send" loading={loading} />
          </form>
        </div>
      )}
    </>
  );
};

export default AddPDOLetter;
